import { trackerDelete, trackerGet, trackerPatch, trackerPost } from '../client';
import type { BotPolicy, BotPolicyCreate, BotPolicyUpdate } from '../types';

export function listBotPolicies() {
  return trackerGet<BotPolicy[]>('/bot-policies');
}

export function getBotPolicy(id: number) {
  return trackerGet<BotPolicy>(`/bot-policies/${id}`);
}

export function createBotPolicy(body: BotPolicyCreate) {
  return trackerPost<BotPolicy>('/bot-policies', body);
}

export function updateBotPolicy(id: number, body: BotPolicyUpdate) {
  return trackerPatch<BotPolicy>(`/bot-policies/${id}`, body);
}

export function setDefaultBotPolicy(id: number) {
  return trackerPost<BotPolicy>(`/bot-policies/${id}/set-default`, {});
}

export function deleteBotPolicy(id: number) {
  return trackerDelete(`/bot-policies/${id}`);
}
